// impersonation
export const SET_IMPERSONATION = "setImpersonation";
export const CLEAR_IMPERSONATION = "clearImpersonation";

// account
export const SET_ACCOUNT = "setAccount";
export const SET_SESSION_TOKEN = "setToken";
export const SET_REFRESH_TOKEN = "setRefreshToken";
export const SET_ACCOUNT_ORGANIZATION = "setAccountOrganization";

// mfa
export const SET_MFA_PENDING = "setMfaPending";
export const CLEAR_MFA_PENDING = "clearMfaPending";

// users
export const SET_USER = "setUser";
export const SET_USER_STATS = "setUserStats";
export const SET_USERS = "setUsers";

// organization
export const SET_ORGANIZATION = "setOrganization";
export const SET_ORGANIZATIONS = "setOrganizations";

// contact
export const SET_CONTACT = "setContact";
export const SET_CONTACTS = "setContacts";

// note
export const SET_NOTE = "setNote";
export const SET_NOTES = "setNotes";

// contact_tag
export const SET_CONTACT_TAG = "setContactTag";
export const SET_CONTACT_TAGS = "setContactTags";

// tag
export const SET_TAG = "setTag";
export const SET_TAGS = "setTags";

// company
export const SET_COMPANY = "setCompany";
export const SET_COMPANIES = "setCompanies";

// bucket
export const SET_BUCKET = "setBucket";
export const SET_BUCKETS = "setBuckets";
export const SET_BUCKET_COUNTS = "setBucketCounts";
export const SET_BUCKET_STATS = "setBucketStats";

// bucket_option
export const SET_BUCKET_OPTION = "setBucketOption";
export const SET_BUCKET_OPTIONS = "setBucketOptions";

// organization_setting
export const SET_ORGANIZATION_SETTING = "setOrganizationSetting";
export const SET_ORGANIZATION_SETTINGS = "setOrganizationSettings";

// opportunity
export const SET_OPPORTUNITY = "setOpportunity";
export const SET_OPPORTUNITIES = "setOpportunities";

// opportunity_stage
export const SET_OPPORTUNITY_STAGE = "setOpportunityStage";
export const SET_OPPORTUNITY_STAGES = "setOpportunityStages";

// opportunity_contact
export const SET_OPPORTUNITY_CONTACT = "setOpportunityContact";
export const SET_OPPORTUNITY_CONTACTS = "setOpportunityContacts";

// integration
export const SET_INTEGRATION = "setIntegration";
export const SET_INTEGRATIONS = "setIntegrations";
export const SET_CONNECT_INTEGRATION = "setConnectIntegration";

// meeting
export const SET_MEETING = "setMeeting";
export const SET_MEETINGS = "setMeetings";
export const SET_MEETING_STATS = "setMeetingStats";

// notification
export const SET_NOTIFICATION = "setNotification";
export const SET_NOTIFICATIONS = "setNotifications";
export const APPEND_NOTIFICATIONS = "appendNotifications";
export const SET_NOTIFICATIONS_PAGINATION = "setNotificationsPagination";
export const PUSH_NOTIFICATION_POPUP = "pushNotificationPopup";
export const NEXT_NOTIFICATION_POPUP = "nextNotificationPopup";
export const CLOSE_NOTIFICATION_POPUP = "closeNotificationPopup";
export const ADD_DISMISSED_BANNER_TIMESTAMP = "addDismissedBannerTimestamp";

//socket
export const SOCKET_BOUND = "socketBound";

// template_folder
export const SET_TEMPLATE_FOLDER = "setTemplateFolder";
export const SET_TEMPLATE_FOLDERS = "setTemplateFolders";

// parent_template_folder
export const SET_PARENT_TEMPLATE_FOLDER = "setParentTemplateFolder";
export const SET_PARENT_TEMPLATE_FOLDERS = "setParentTemplateFolders";

// parent_template_folder
export const SET_TEMPLATE = "setTemplate";
export const SET_TEMPLATES = "setTemplates";

// fullenrich
export const SET_FULLENRICH = "setFullenrich";

// reports
export const SET_DASHBOARD_STATS = "setDashboardStats";
export const SET_ANALYTIC_REPORTS = "setAnalyticReports";
export const SET_CONTACT_MOVEMENTS = "setContactMovements";
export const SET_CALL_CONNECT_RATE = "setCallConnectRate";
export const SET_MEETING_BOOKING_METRICS = "setMeetingBookingMetrics";

// buckey_journey
export const SET_BUCKET_JOURNEY = "setBucketJourney";
export const SET_BUCKET_JOURNIES = "setBucketJournies";

// subscription
export const SET_SUBSCRIPTION = "setSubscription";
export const SET_SUBSCRIPTIONS = "setSubscriptions";
export const SET_ORGANIZATION_ACTIVE_SUBSCRIPTION = "setOrganizationActiveSubscription";
export const INVALIDATE_SUBSCRIPTION_CACHE = "invalidateSubscriptionCache";
export const SET_ORGANIZATION_SUBSCRIPTIONS = "setOrganizationSubscriptions";
export const SET_STRIPE_SESSION_INFO = "setStripeSessionInfo";
export const SET_STRIPE_BILLING_PORTAL_URL = "setStripeBillingPortalUrl";

// billing
export const SET_USAGE_STATS = "setUsageStats";
export const SET_USAGE_HISTORY = "setUsageHistory";
export const SET_INVOICES = "setInvoices";
export const SET_PAYMENT_METHODS = "setPaymentMethods";
export const SET_SUBSCRIPTION_STATUS = "setSubscriptionStatus";
export const SET_TRIAL_STATUS = "setTrialStatus";
export const SET_HAS_COMPLETED_ONBOARDING = "setHasCompletedOnboarding";
export const SET_PERSISTENT_BANNER = "setPersistentBanner";
export const CLEAR_PERSISTENT_BANNER = "clearPersistentBanner";

// call_log
export const SET_CALL_LOG = "setCallLog";
export const SET_CALL_LOGS = "setCallLogs";

// phone_number
export const SET_PHONE_NUMBER = "setPhoneNumber";
export const SET_PHONE_NUMBERS = "setPhoneNumbers";
export const SET_PHONE_NUMBER_ROTATIONS = "setPhoneNumberRotations";

// call_disposition
export const SET_CALL_DISPOSITION = "setCallDisposition";
export const SET_CALL_DISPOSITIONS = "setCallDispositions";

// lead_source
export const SET_LEAD_SOURCE = "setLeadSource";
export const SET_LEAD_SOURCES = "setLeadSources";

// activity_log
export const SET_ACTIVITY_LOG = "setActivityLog";
export const SET_ACTIVITY_LOGS = "setActivityLogs";

// search
export const SET_GLOBAL_SEARCH = "setGlobalSearch";

// router_loader
export const SET_ROUTER_LOADER = "setRouterLoader";

// error
export const SET_ERRORMSG = "setErrorMsg";
